import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 60000 });

export const fetchCategories = () => api.get("/categories").then((r) => r.data);
export const fetchTools = (params = {}) =>
    api.get("/tools", { params }).then((r) => r.data);
export const fetchTool = (slug) => api.get(`/tools/${slug}`).then((r) => r.data);
export const generate = (payload) =>
    api.post("/generate", payload).then((r) => r.data);
export const generateImage = (payload) =>
    api.post("/generate-image", payload).then((r) => r.data);
export const lookupWord = (word) =>
    api.get(`/dictionary/${encodeURIComponent(word)}`).then((r) => r.data);
export const askAi = (payload) => api.post("/ask", payload).then((r) => r.data);
